import Translation from './Translation';
export default Translation;
